import { SrSalesOrderType } from '@plato/data/starrocks/types';
import { createContext } from 'react';

export type AllDrawersProps = {
    canAddToDraft?: boolean;
};

export type DrawersContextType = {
    openEventDetails: (eventId: string, eventDate: string) => void;
    openNoteDetails: (noteId: string) => void;
    openOrderQuoteDetails: (type: SrSalesOrderType | `${SrSalesOrderType}`, id: string) => void;
    openProductDetails: (nextProductId: string, customerId?: string) => void;
    openTaskDetails: (taskId: string) => void;
};

export const DrawersContext = createContext<DrawersContextType | undefined>(undefined);
